import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettyjson',
})
export class PrettyjsonPipe implements PipeTransform {
  transform(
    value: any,
    options: { escapeHtmlBracket: boolean } | undefined = undefined
  ): any {
    let jsonStr: string = JSON.stringify(value, null, 2);

    if (options?.escapeHtmlBracket) {
      jsonStr = jsonStr.replaceAll('<', '&lt;').replaceAll('>', '&gt;');
    }

    // Syntax highlighting
    jsonStr = jsonStr.replaceAll(
      /("(?:\\.|[^"\\])*"\s*:?)|\b(true|false|null)\b|(-?\d+\.?\d*)/g,
      match => {
        let cls = 'number';
        if (match.startsWith('"')) {
          cls = match.endsWith(':') ? 'key' : 'string';
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }
        return `<span class="${cls}">${match}</span>`;
      }
    );

    return jsonStr;
  }
}
